export const ASSETS = {
  logoMain:
    "https://customer-assets.emergentagent.com/job_b9559d1c-8bf7-4edd-85c5-2b375bf5295a/artifacts/fk53w22k_Nexus%20Benin%20en-tete%20logo.jpg",
  logoMark:
    "https://customer-assets.emergentagent.com/job_b9559d1c-8bf7-4edd-85c5-2b375bf5295a/artifacts/l3e2kgvn_BC%20NH%20MBonly.png",
  leaderPortrait:
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/zquv8q67_nouemou%20webpage.png",
  martinPortrait:
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/4drsyu23_martin%20nexus.png",
  martinCard:
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/3j8c70pi_Nexus%20BC%20ME%202.png",
  irrigationBox:
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/sn32ddlo_Irrigation%20box.png",
  pumpHero:
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/md4w3ofj_SLP%200%2C5%20HP%20Ennos%20without%20Background.png",
  ennosLogo:
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/xfcbsw79_image.png",
  successStory01:
    "https://customer-assets.emergentagent.com/job_b9559d1c-8bf7-4edd-85c5-2b375bf5295a/artifacts/f4ql932z_success_story_01.png",
  successStory02:
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/grye9ry9_success_story_02_investir_au_benin.png",
  successStory03:
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/efp82rle_Success_story_3.png",
  pumpCatalog:
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/ccr8sofg_ennos%20solar%20pump%20catalog%202025.pdf",
  donationPoster:
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/mzwhpqav_fisherman%20village%20donation%20.png",
};

export const DOWNLOADS = {
  "datasheet-05hp":
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/20qjpore_Datasheet%200.5HP.pdf",
  "catalog-2025":
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/ccr8sofg_ennos%20solar%20pump%20catalog%202025.pdf",
  "manual-2020":
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/y27xxlr8_Sunlight_pump_Operational_Manual_2020.pdf",
  "install-guide-05hp":
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/6zpl4iwb_Comment%20installer%20la%20sunlight%20pump%20de%200.5%20HP.pdf",
  "dos-and-donts":
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/fc1llwa0_Dos%20and%20don%27ts.pdf",
  "app-guide":
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/nj00hxg6_App%20Guide%20Druckformat.pdf",
  "ennos-brochure-fr":
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/2ltl5apn_Ennos%20Brochure-FR_web.pdf",
  "sunlight-pump-use-cases":
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/xom40wfe_sunlight-pump-use-cases.pdf",
  "drip-kit-manual":
    "https://customer-assets.emergentagent.com/job_irrigation-nexus/artifacts/0l06xifx_Drip%20Kit%20Manual%20%281%29.pdf",
};

export const DONATION_PROJECT = {
  mapLink: "https://maps.app.goo.gl/Ym6WHZFyrWisaXMp9",
};

export const CONTACT = {
  whatsappLink: "https://wa.me/2290169162876",
  phoneDisplay: "+229 01 69 16 28 76",
  emailPrimary: "sales@nexus-benin.com",
  emailSecondary: "hortense.nouemou@nexus-benin.com",
  location: "Agoué / Ayi-Guinnou, Grand-Popo, Bénin",
  company: "Nexus Benin SAS",
  tradeName: "NEXUS BENIN",
  country: "Bénin",
  department: "Mono",
  commune: "Grand-Popo",
  arrondissement: "Agoué",
  quartier: "Ayi-Guinnou",
  mapLink: "https://maps.app.goo.gl/zVnxfrcPXQf5vSxP7",
  mapDirections:
    "https://www.google.com/maps/dir/?api=1&destination=Agou%C3%A9%20Ayi-Guinnou%20Grand-Popo%20Benin",
  mapEmbed:
    "https://www.google.com/maps?q=Agou%C3%A9%20Ayi-Guinnou%20Grand-Popo%20Benin&output=embed",
  ifu: "3202113415129",
  rccm: "RCCM RB/ABC/21 B 4718",
  linkedin: "https://www.linkedin.com/company/nexus-benin-sas",
};

export const teamMembers = [
  {
    id: "hortense",
    name: "Hortense N’ouemou",
    photo: ASSETS.leaderPortrait,
    card: ASSETS.logoMark,
  },
  {
    id: "martin",
    name: "Martin Ehlers",
    photo: ASSETS.martinPortrait,
    card: ASSETS.martinCard,
  },
];

export const successStoryImages = [
  ASSETS.successStory01,
  ASSETS.successStory02,
  ASSETS.successStory03,
];